// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"MenuSidebar_sidebarContainer__sJGCn","closeButton":"MenuSidebar_closeButton__v-ZxZ"};